import { ModuleWithProviders, NgModule } from '@angular/core';
import { CustomersServiceWithCache } from './customers-cache.service';

@NgModule()
export class CustomersServiceWithCacheModule {
  static forRoot(): ModuleWithProviders<CustomersServiceWithCacheModule> {
    return {
      ngModule: CustomersServiceWithCacheModule,
      providers: [CustomersServiceWithCache]
    };
  }
}
